import { Box, Button, Flex, Text } from "../../../components";
import React from "react";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { useRouter } from "next/router";
import Image from "next/image";
import ClockIcon from "public/images/clock.svg";
import UserIcon from "public/images/user.svg";
import TagIcon from "public/images/tag.svg";
import ArrowRightIcon from "public/images/super-arrow-right.svg";
import styled from "styled-components";
import moment from "moment";

interface FacilityDetailProps {
  id: number;
  key: string | number;
  name: string;
  roomSize: string;
  startDate: string;
  endDate: string;
  pricePerHour: number;
  desc: string;
  imageUrls: string[];
}

const StyledWrapper = styled("div")`
  font-family: "Noto Sans Thai", sans-serif;
`;

const StyledImageContainer = styled("div")`
  width: 100%;
  flex: unset;
  ${({ theme }) => theme.mediaQueries.md} {
    flex: unset;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    flex: 1;
  }

  img {
    object-fit: cover !important;
    width: 100% !important;
    position: relative !important;
    height: unset !important;
  }
`;

const StyledContentContainer = styled(Box)`
  flex: unset;
  width: 90%;
  margin: 0 auto;
  ${({ theme }) => theme.mediaQueries.md} {
    width: 90%;
    margin: 0 auto;
    flex: unset;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    width: 100%;
    flex: 1;
  }
`;

const FacilityDetail: React.FC<FacilityDetailProps> = ({
  id,
  name,
  roomSize,
  startDate,
  endDate,
  pricePerHour,
  desc,
  imageUrls,
}) => {
  const screens = useBreakpoint();
  const router = useRouter();
  return (
    <StyledWrapper>
      <Flex
        style={screens.xs ? { gap: "16px" } : { gap: "40px" }}
        flexWrap={screens.xs ? "wrap" : "unset"}
      >
        <StyledImageContainer>
          {imageUrls && imageUrls.length > 0 && (
            <Image src={imageUrls[0]} alt="Facility Image" fill />
          )}
        </StyledImageContainer>
        <StyledContentContainer>
          <Text
            fontSize={screens.xs ? "20px" : "27px"}
            lineHeight="26px"
            fontWeight="700"
          >
            {name}
          </Text>
          <Flex
            flexDirection={screens.xs ? "row" : "column"}
            alignItems={screens.xs ? "center" : "flex-start"}
            justifyContent={screens.xs ? "space-between" : "unset"}
          >
            <Flex mt="8.5px" alignItems="center" style={{ gap: "8px" }}>
              <Image src={ClockIcon} alt="clock" />
              <Text fontSize="14px" lineHeight="19px" fontWeight="300">
                {moment(startDate).utc().utcOffset(7).format("HH:mm")} -{" "}
                {moment(endDate).utc().utcOffset(7).format("HH:mm")}
              </Text>
            </Flex>
            <Flex alignItems="center" mt="9px" style={{ gap: "8px" }}>
              <Image src={UserIcon} alt="User Icon" />
              <Text fontSize="14px" lineHeight="19px" fontWeight="300">
                {roomSize} PEOPLE
              </Text>
            </Flex>
          </Flex>
          <Flex alignItems="center" mt="8.5px" style={{ gap: "8px" }}>
            <Image src={TagIcon} alt="Tag Icon" />
            <Flex alignItems="baseline" style={{ gap: "10px" }}>
              <Text
                color="#FFD600"
                fontWeight="700"
                fontSize="24px"
                lineHeight="32px"
              >
                {pricePerHour}
              </Text>
              <Text
                color="#FFD600"
                fontWeight="700"
                fontSize="14px"
                lineHeight="19px"
              >
                THB / HRS
              </Text>
            </Flex>
          </Flex>
          <Text
            mt={screens.xs ? "16px" : "28px"}
            fontSize="14px"
            lineHeight="19px"
          >
            {" "}
            {desc}
          </Text>
          <Flex
            mt={screens.xs ? "16px" : "40px"}
            style={{ cursor: "pointer", gap: "5px" }}
            onClick={() => router.push(`/facilities/${id}`)}
          >
            <Text
              textTransform="uppercase"
              letterSpacing="0.2em"
              fontSize="12px"
              lineHeight="15px"
              style={{ textShadow: "0px 0px 4px #9ACAF4" }}
              fontFamily="Orbitron"
            >
              Read more
            </Text>
            <Image src={ArrowRightIcon} alt="Arrow Right" />
          </Flex>
        </StyledContentContainer>
      </Flex>
    </StyledWrapper>
  );
};

export default FacilityDetail;
